import { matcher, MatchType } from "@cdv/jazz-ui";
import View from "../ui/View";
import { Resource } from "../utils";
import Content from "./Content";

export default matcher({ resource: Resource.Game })
  .set(MatchType.View, View)
  .set(MatchType.Content, Content)
  .entries();
